import en from "./languages/en";

const languages = {
  en
};

export default languages;
